import { Model } from 'app/model/backendmodel';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { Named, Owned } from 'app/model/base/named';
import { OracleCloudStorageLocation } from 'app/model/dataset/location/oracle-cloud-storage.location';
import { FileLocationAdapter } from './file-location.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(OracleCloudStorageLocation),
    adapts: {
        type: '*',
        bucketName: '*',
        folderPath: '*',
        fileName: '*'
    }
})
export class OracleCloudStorageLocationAdapter extends FileLocationAdapter<OracleCloudStorageLocation, Model.DatasetLocation> {
    public _toResource(store: OracleCloudStorageLocation): Model.OracleCloudStorageLocation {
        const resource: Model.OracleCloudStorageLocation = {
            type: OracleCloudStorageLocation.MODEL.name,
            bucketName: ValueAdapter.toResource(store, OracleCloudStorageLocation.CONTAINER) || undefined,
            folderPath: ValueAdapter.toResource(store, OracleCloudStorageLocation.FOLDER_PATH) || undefined,
            fileName: ValueAdapter.toResource(store, OracleCloudStorageLocation.FILE_NAME) || undefined
        };
        return resource;
    }

    public _toModel(resource: Model.OracleCloudStorageLocation, owner: Named): OracleCloudStorageLocation {
        const model = Owned.create<OracleCloudStorageLocation>(OracleCloudStorageLocation.MODEL, owner);
        ValueAdapter.toModel(model, OracleCloudStorageLocation.CONTAINER, resource.bucketName);
        ValueAdapter.toModel(model, OracleCloudStorageLocation.FOLDER_PATH, resource.folderPath);
        ValueAdapter.toModel(model, OracleCloudStorageLocation.FILE_NAME, resource.fileName);
        return model;
    }
}
